const updates = [
  {
    date: '2026-07-31',
    time: '今日',
    title: '《阿凡达4：火与烬》高清版正式上线',
    desc: '詹姆斯·卡梅隆执导的史诗科幻系列第四部，延续潘多拉星球的壮丽冒险，视觉效果再次突破想象边界。',
    tag: '新片上线',
    tagColor: 'bg-primary-50 text-primary-700',
  },
  {
    date: '2026-07-30',
    time: '昨天',
    title: '暑期档专题"清凉影院"活动开启',
    desc: '精选50部夏日必看影片，涵盖喜剧、动画、冒险等多种类型，陪你度过炎炎夏日。',
    tag: '活动',
    tagColor: 'bg-accent-50 text-accent-700',
  },
  {
    date: '2026-07-29',
    title: '播放线路全面升级，加载速度提升40%',
    desc: '完成全国CDN节点扩容，新增三条高速线路，确保高峰期观影依旧流畅不卡顿。',
    tag: '系统升级',
    tagColor: 'bg-secondary-50 text-secondary-700',
  },
  {
    date: '2026-07-28',
    title: '《封神第三部》超清导演剪辑版独家上线',
    desc: '含30分钟未公开片段，导演亲自操刀重新调色，呈现最完整的封神宇宙终章。',
    tag: '新片上线',
    tagColor: 'bg-primary-50 text-primary-700',
  },
  {
    date: '2026-07-27',
    title: '电影大全分类体系优化升级',
    desc: '新增"导演专辑"和"年代经典"两大分类维度，找片更精准，发现更多隐藏好片。',
    tag: '功能更新',
    tagColor: 'bg-accent-50 text-accent-700',
  },
  {
    date: '2026-07-26',
    title: '法国戛纳电影节获奖作品专题上线',
    desc: '收录本届戛纳金棕榈奖及评审团大奖等主要奖项作品，高清中字完整呈现。',
    tag: '专题上线',
    tagColor: 'bg-primary-50 text-primary-700',
  },
  {
    date: '2026-07-25',
    title: '移动端观影体验全面优化',
    desc: '适配最新iOS与Android系统，手势操作更流畅，小屏观影同样享受高清画质。',
    tag: '体验升级',
    tagColor: 'bg-secondary-50 text-secondary-700',
  },
  {
    date: '2026-07-24',
    title: 'BBC年度十佳纪录片全系列引进',
    desc: '从自然奇观到人文探索，9分以上神级纪录片一次性放送，纪录片爱好者不可错过。',
    tag: '新片上线',
    tagColor: 'bg-primary-50 text-primary-700',
  },
  {
    date: '2026-07-23',
    title: '用户反馈系统上线，你的意见我们听见',
    desc: '新增影片报错与建议通道，每一条反馈都将直接推动平台改进，共建更好的观影社区。',
    tag: '公告',
    tagColor: 'bg-accent-50 text-accent-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              更新动态
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              快看影视最新内容上线与平台动态速递
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300/60 hidden md:block"></div>

            <div className="space-y-5">
              {updates.map((item, i) => (
                <div key={i} className="relative flex gap-5">
                  <div className="hidden md:flex flex-shrink-0 relative z-10 w-10 h-10 rounded-full bg-background-50 border-2 border-primary-300 items-center justify-center">
                    <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
                  </div>
                  <div className="flex-1 bg-background-50 rounded-xl p-5 border border-background-200/70 min-w-0">
                    <div className="flex items-center gap-3 mb-2 flex-wrap">
                      <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">
                        {item.date}
                      </span>
                      <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${item.tagColor}`}>
                        {item.tag}
                      </span>
                      {item.time && (
                        <span className="px-1.5 py-0.5 rounded bg-primary-50 text-primary-600 text-xs font-medium">
                          {item.time}
                        </span>
                      )}
                    </div>
                    <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}